import { getCurrentInstance } from 'vue';

export default function useGenerateEditorClass() {
  const _this = getCurrentInstance()?.proxy as any;
  if (!_this) return;

  const generateEditorClass = () => {
    return Object.entries(_this.editorClasses)
      .reduce((acc: string[], [className, condition]) => {
        if (condition) {
          acc.push(className);
        }
        return acc;
      }, [])
      .join(' ');
  };

  return {
    generateEditorClass,
  };
}
